import { motion } from "framer-motion";
import React from "react";

const controller = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

const controller_2 = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};
let ResponsiveVariants = {};
const isMobile = window.innerWidth < 768;

if (!isMobile) {
  ResponsiveVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
  };
}
const Project = ({ title, description }) => {
  const overlay = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500
    bg-grey z-30 flex flex-col justify-center items-center text-center -p-16b text-deep-blue
    
    `;
  return (
    <motion.div className="relative" variants={ResponsiveVariants}>
      <div className={overlay}>
        <p className="font-semibold font-lato">{title}</p>
        <p className="font-semibold font-poppins mt-3 p-4">{description}</p>
      </div>
      <img
        src={require(`/src/Resource/image/projects/${title}.png`)}
        alt={title}
      />
    </motion.div>
  );
};
export default function Projects() {
  return (
    <section id="projects" className="pt-20 pb-10">
      <motion.div
        className="md:w-2/4 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-lato font-semibold text-4xl ">
            <span className="text-red">Pro</span>jects
          </p>
        </div>
      </motion.div>

      <div className="flex justify-center mt-10">
        <motion.div
          className="sm:grid sm:grid-cols-3"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={controller}
        >
          <Project
            title="Find@Partner"
            description={
              "Find@Partner is a real time chat application it is built with django and sqlite3 database "
            }
          />
          <Project
            title="Bookker"
            description={
              "Bokker is a BookStore application it is built with django and sqlite3 database "
            }
          />
          <Project
            title="BillingSystem"
            description={
              "BillingSystem is a retail shop application it is built with mern stack "
            }
          />
          <Project
            title="Blog"
            description={
              "Blog is simple post application it is core html and css "
            }
          />
          <Project
            title="Chat UI"
            description={
              "Chat ui is a ui for chat application it is built react and material ui "
            }
          />
          <Project
            title="DigitalLibrary"
            description={
              "DigitalLibrary is a online book reading application it is built with mern stack "
            }
          />
          <Project
            title="ImageCutter"
            description={
              "ImageCutter is a image resize  application it is built with electron js "
            }
          />
          <Project
            title="LoginPage"
            description={
              "LoginPage is a Login UI  it is built with html and css "
            }
          />
          <Project
            title="Meetup"
            description={
              "Meetup is a Meeting application it is built with react "
            }
          />
          <Project
            title="Moviez"
            description={
              "Moviez is a movie description  application it is built with react "
            }
          />
          <Project
            title="Transor"
            description={
              "Transor is a expensive tracker application it is built with mern "
            }
          />
          <Project
            title="SchoolManagement"
            description={
              "SchoolManagement is a SchoolManagement  application it is built with react and mysql database "
            }
          />
        </motion.div>
      </div>
    </section>
  );
}
